module.exports = __webpack_public_path__ + "img/bigcommerce_1.1a4021c5.png";